import React, { useState } from 'react'
import { MaterialTable } from '../generic'
import { printCurrency, printDate } from '../../lib/helpers'
import { AuthConsumer } from '@mymeerkat/react-auth-helper';
import { Button, Modal } from '../generic'
import { useConfirm } from "material-ui-confirm";
import { withApollo } from 'react-apollo';
import gql from 'graphql-tag'

const FORGIVE_GROUP_CONTRIBUTION = gql`
  mutation ($id: String!, $input: UpdateGroupContributionInput!){
    updateGroupContribution(id: $id, input: $input) {
       id
        period
        payments {
          amount
        }
        contributions { 
          amount
        }
        isPaid
        forgiven
        unitDate
    }  
  }
`

const CREATE_NOTE = gql`
  mutation($input: CreateNoteInput! ) {
    createNote(input: $input) {
      id
      text
      associatedWith {
        type
        id
      }
      createdAt
      createdBy {
          description
        }
      updatedAt
      updatedBy {
        email
        description
      }
    }
  }
`;

let ContributionsHistory = ({ contributions, balance, client }) => {
  const data = contributions || []
  const confirm = useConfirm();
  const [disabled, setDisabled] = useState(false)


  const createNote = (input) => {
    console.log('create client note', {...input})
    client
      .mutate({
        mutation: CREATE_NOTE,
        variables: {
          input: { ...input },
        }
      })
    .then(response => console.log('created note', response) )
  }

  const handleForgive = (id, period, currentValue) => {
    console.log("> Running forgive for contribution with ID ", id)
    const associatedWith = [
      { type: 'GroupContribution', id: id }
    ] 

    confirm({
      title: `Forgive group contribution for ${period}?`,
      cancellationButtonProps: { variant: 'contained', color: 'default' },
      confirmationButtonProps: { variant: 'contained', color: 'primary' },
      description: currentValue === true 
        ? `Press 'OK' to go ahead with unforgiving the contribution, press 'CANCEL' to stop the operation.` 
        : `Press 'OK' to go ahead with forgiving the contribution, press 'CANCEL' to stop the operation.`
    })
      .then(() => {
        setDisabled(true)
        createNote({ 
          text: `Group contribution for ${period} has been ${currentValue === true ? "forgiven" : "unforgiven"} for this group`,
          tags: ['Forgive/Unforgive group'],
          associatedWith: [...associatedWith]
        })
        return client.mutate({
          mutation: FORGIVE_GROUP_CONTRIBUTION,
          variables: {
            id,
            input: { forgiven: !currentValue }
          }
        })
      .then(() => setDisabled(false))
    })
  }

  // const createNote = (input) => {
  //   console.log('create client note', {...input})
  //   client
  //     .mutate({
  //       mutation: CREATE_NOTE,
  //       variables: {
  //         input: { ...input },
  //       }
  //     })
  //   .then(response => console.log('created note', response) )
  // }

  const cols = [
    {
      Header: 'Period',
      accessor: 'period',
    },
    {
      Header: 'Contribution Amount',
      accessor: 'contributions',
      Cell: ({ value }) => printCurrency((value || []).reduce((total, contribution) => total + contribution.amount, 0))
    },
    {
      Header: 'Payments Total',
      accessor: 'payments',
      Cell: ({ value }) => printCurrency((value || []).reduce((total, payment) => total + payment.amount, 0))
    },
    {
      Header: 'Fully Paid',
      accessor: 'isPaid',
      Cell: ({ value }) => value ? 'Yes' : 'No'
    },
    {
      Header: 'Date Paid',
      accessor: 'unitDate',
      Cell: ({ value }) => printDate(value)
    },
    {
      Header: 'Forgiven?',
      accessor: 'forgiven',
      Cell: ({ value }) => value ? 'Yes' : 'No'
    },
    {
      id: 'forgive',
      Cell: ({ row }) => 
      {
        const { id, period, isPaid, forgiven } = row.original
        return <AuthConsumer>
          {({ inGroup }) => (
          !isPaid && inGroup("forgive-group-contribution") && <Button disabled={disabled} color="secondary" onClick={() => handleForgive(id, period, forgiven)}> {forgiven ? "Unforgive" : "Forgive"} </Button>
          )}
        </AuthConsumer>   
      }
    }
  ]

  return (
    <>
      <div style={{ fontVariant: 'small-caps', fontSize: 21, fontWeight: 400 }}>
        Contributions History | Balance: {printCurrency(balance)}
      </div>
      {data && <MaterialTable columns={cols} data={data} />}
    </>
  )
}

ContributionsHistory = withApollo(ContributionsHistory);
export default ContributionsHistory
